import { useEffect, useRef } from 'react';
import Done from '@nerdwallet/react-icon/material/Done';
import Close from '@nerdwallet/react-icon/material/Close';

export const RenamePanel = ({
  currentValue,
  handleCancel,
  handleRename,
}: {
  currentValue: string;
  handleCancel: () => void;
  handleRename: (value: string | undefined) => void;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    handleRename(inputRef.current?.value);
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = currentValue;
      inputRef.current.focus();
    }
  }, [currentValue]);

  return (
    <form style={{ position: 'relative' }} onSubmit={handleSubmit}>
      <input style={{ border: 'none', userSelect: 'all' }} ref={inputRef} />
      <div
        style={{
          display: 'flex',
          position: 'absolute',
          zIndex: 1,
          bottom: '-21px',
        }}
      >
        <button
          onClick={handleCancel}
          type="button"
          aria-label="Cancel"
          style={{ border: '1px solid, #b40000' }}
        >
          <Close color="#b40000" />
        </button>
        <button
          type="submit"
          aria-label="Done"
          style={{ border: '1px solid, #008254' }}
        >
          <Done color="#008254" />
        </button>
      </div>
    </form>
  );
};
